import React, { FC, memo } from 'react';
import { styled } from 'linaria/react';
import { Divider, Text } from '@shared/ui/atoms';
interface InfoRowsListProps {
  rows: InfoRowProps[];
}
export const InfoRowsList: FC<InfoRowsListProps> = ({
  rows
}) => <InfoRowsListWrapper>
    {rows.map((row, index) => <React.Fragment key={row.label}>
        <InfoRow label={row.label} value={row.value} />
        {index !== rows.length - 1 && <Divider />}
      </React.Fragment>)}
  </InfoRowsListWrapper>;
const InfoRowsListWrapper = /*#__PURE__*/styled('div')({
  name: "InfoRowsListWrapper",
  class: "ih38bnu",
  propsAsIs: false
});
interface InfoRowProps {
  label: string;
  value: string | React.ReactNode | number;
}
const InfoRow: FC<InfoRowProps> = memo(({
  label,
  value
}) => <InfoRowWrapper>
    <Text family="MTSCompact" size={{
    desktop: 'pL',
    mobile: 'pM'
  }} weight="medium" color="secondary">
      {label}
    </Text>
    <Text family="MTSCompact" size={{
    desktop: 'pL',
    mobile: 'pM'
  }} weight="medium" color="primary">
      {value}
    </Text>
  </InfoRowWrapper>);
const InfoRowWrapper = /*#__PURE__*/styled('div')({
  name: "InfoRowWrapper",
  class: "i1hq2t7y",
  propsAsIs: false
});

require("./InfoRowsList.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./InfoRowsList.tsx");